var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuwaei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30px",
    height: "30px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "transparent",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "transparent",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_ag",
    stroke: "#414141",
    strokeWidth: 0.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1009995,0 C2.70511277,0 0,2.70464098 0,10.0990356 L0,25.9009714 C0,33.295359 2.70511277,36 10.1009995,36 L25.894186,36 C33.3598634,36 36,33.295359 36,25.9009714 L36,10.0990356 C36,2.70464098 33.2948872,0 25.8990005,0 L10.1009995,0 Z",
    id: "Fill-1",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7030515,20.879251 L17.1483192,20.879251 L16.423226,19.1929607 L15.7030515,20.879251 Z M15.3471598,21.7290511 L14.9183536,22.7102135 L13.9421108,22.7102135 L16.0181459,18.0003593 L16.8618698,18.0003593 L18.929514,22.7102135 L17.9272303,22.7102135 L17.5039216,21.7290511 L15.3471598,21.7290511 Z M31.0564529,22.7067407 L32,22.7067407 L32,18 L31.0564529,18 L31.0564529,22.7067407 Z M27.3010716,20.6848126 L29.0403117,20.6848126 L29.0403117,19.8266216 L27.3010716,19.8266216 L27.3010716,18.8619524 L29.8258776,18.8619524 L29.8258776,18.0034721 L26.3578138,18.0034721 L26.3578138,22.7099234 L29.9167313,22.7099234 L29.9167313,21.8514431 L27.3010716,21.8514431 L27.3010716,20.6848126 Z M23.5520559,21.2409296 L22.4823553,18 L21.7017082,18 L20.6320075,21.2409296 L19.5909518,18.0026041 L18.5730436,18.0026041 L20.2159325,22.7135169 L21.0073552,22.7135169 L22.0787219,19.6188734 L23.1501586,22.7135169 L23.9484556,22.7135169 L25.5870044,18.0026041 L24.5954263,18.0026041 L23.5520559,21.2409296 Z M12.5017619,20.697833 C12.5017619,21.464013 12.121276,21.8734332 11.4303252,21.8734332 C10.7356129,21.8734332 10.3531017,21.4521499 10.3531017,20.6651373 L10.3531017,18.0031835 L9.39682343,18.0031835 L9.39682343,20.697833 C9.39682343,22.0233135 10.1334904,22.7834165 11.4173048,22.7834165 C12.7138502,22.7834165 13.4571721,22.0088456 13.4571721,20.6584824 L13.4571721,18.0003593 L12.5017619,18.0003593 L12.5017619,20.697833 Z M7.11535481,18.0003593 L8.07105434,18.0003593 L8.07105434,22.7131062 L7.11535481,22.7131062 L7.11535481,20.799103 L4.95627822,20.799103 L4.95627822,22.7131062 L4,22.7131062 L4,18.0003593 L4.95627822,18.0003593 L4.95627822,19.9012721 L7.11535481,19.9012721 L7.11535481,18.0003593 Z",
    id: "Fill-1",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,12 C14.6912616,12 12,9.30844907 12,6 L12.8475116,6 C12.8475116,8.84085648 15.1591435,11.1521991 18,11.1521991 C20.8408565,11.1521991 23.1524884,8.84085648 23.1524884,6 L24,6 C24,9.30844907 21.3084491,12 18,12",
    id: "Fill-3",
    fill: "#414141"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuwaei);
export default __webpack_public_path__ + "static/media/huwaei.c421b7a04fcea2b101aba83940096ecb.svg";
export { ForwardRef as ReactComponent };